var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoleAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#EA8016"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87087 4.8661C8.01744 4.56824 8.44211 4.56824 8.58868 4.8661L9.56068 6.84146C9.6189 6.95978 9.7317 7.0418 9.86221 7.06072L12.0233 7.37392C12.351 7.42141 12.4824 7.82372 12.2459 8.05547L10.677 9.59298C10.5828 9.68533 10.5401 9.81823 10.5631 9.94817L10.9373 12.0686C10.9948 12.3946 10.654 12.6454 10.3599 12.4935L8.41323 11.4888C8.29814 11.4294 8.16141 11.4294 8.04632 11.4888L6.09967 12.4935C5.80551 12.6454 5.46477 12.3946 5.5223 12.0686L5.89648 9.94817C5.91942 9.81823 5.87679 9.68533 5.78254 9.59298L4.21366 8.05547C3.97718 7.82372 4.10857 7.42141 4.43626 7.37392L6.59734 7.06072C6.72785 7.0418 6.84065 6.95978 6.89887 6.84146L7.87087 4.8661Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleAdmin);
export default __webpack_public_path__ + "static/media/role-admin.5836d5ff061a7f32fa246d6b3e1a6c8b.svg";
export { ForwardRef as ReactComponent };